import '.el{font-size:1.125rem;}.ssr-plugin'
import '.e7{line-height:1.75rem;}.ssr-plugin'
import '.eg{text-decoration:none;}.ssr-plugin'
import '.fy{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="el e7"
    >
      {translations.privacySubtitle}{' '}
      <a className="eg fy"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="eg fy"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
